import { AgreementProvider } from '../AgreementProvider';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class AgreementProviderFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/agreement`, headers);
  }

  public createAgreementProvider(token: string): AgreementProvider {
    return new AgreementProvider(this.apiClientFactory.createAuthorizedClient(token));
  }
}
